module.exports = __webpack_public_path__ + "static/assets/6b73c1dd54524c22aa4695fc442cadaa.png";